import styled from '@emotion/styled'

import { colors } from '../../theme/colors'
import spacing from '../../theme/spacing'

const isSpacing = (space: keyof typeof spacing | string): space is keyof typeof spacing =>
  (space as keyof typeof spacing) in spacing

const parsePadding = (padding: string) =>
  padding
    .split(/\s/)
    .map(p => (isSpacing(p) ? spacing[p] : p))
    .join(' ')

interface BoxProps {
  backgroundColor?: keyof typeof colors
  border?: string
  borderRadius?: string
  fullHeight?: boolean
  padding?: string
}

export const Box = styled.div<BoxProps>`
  ${({ backgroundColor, theme }) => backgroundColor && `background-color: ${theme.colors[backgroundColor]}`};
  ${({ border }) => border && `border: ${border}`};
  ${({ borderRadius }) => borderRadius && `border-radius: ${borderRadius}`};
  ${({ fullHeight }) => fullHeight && `min-height: 100%`};
  ${({ padding }) => padding && `padding: ${parsePadding(padding)}`};
`
